import ResourceService from './resource.service'

class LanguageService extends ResourceService {
  static get resource() {
    return 'language'
  }
}

export default LanguageService
